import type { Asset, AssetTag } from 'bundles/cml/shared/types/assetTypes';

export const getAssetTag = (asset: Asset | undefined, tagName: string) => {
  return asset?.tags?.find((tag: AssetTag) => tag.name === tagName)?.value || '';
};
